import { getSubscriptionById } from '@vista/omnichannel-components-domain';
export const getLabelForRecurringSubscription = (memberSubscription) => {
    if (!memberSubscription)
        return undefined;
    const { subscriptionId, billingDetails } = memberSubscription;
    if (!billingDetails.isRecurring)
        return undefined;
    const subscription = getSubscriptionById(subscriptionId);
    return subscription === null || subscription === void 0 ? void 0 : subscription.name;
};
